import {util} from '../../utils'
const getters = {
  demo: {
    getFirst: ''
  },
  sys: {
    getUserDimensionProps: ''
  }
}
util.initializeConstants(getters, 'biz-getter')
export default getters
